import {useCallback} from 'react';
import AnalyticsService, {
  eventNames,
} from '@/services/analytics/AnalyticsService';

type PurchaseProcessEndedEventParams = {
  flow_id?: string;
  presentation_id: string;
  process_id: string;
  product_id: string;
  result: string;
  error?: string;
  product_name: string;
};

function usePurchaseProcessEndedEvent(flowName?: string) {
  const purchaseProcessEnded = useCallback(
    ({
      flow_id = '',
      presentation_id,
      process_id,
      product_id,
      result,
      error = '',
      product_name,
    }: PurchaseProcessEndedEventParams) => {
      const flow = flowName ? AnalyticsService.getFlow(flowName) : undefined;
      AnalyticsService.dispatchEvent(
        eventNames.CONTENT_STUDIO_STORE_PURCHASE_PROCESS_ENDED,
        {
          flow_id: flow?.flow_id || flow_id,
          presentation_id,
          process_id,
          product_id,
          result,
          error,
          product_name,
        }
      );
    },
    []
  );

  return {purchaseProcessEnded};
}

export default usePurchaseProcessEndedEvent;
